import { useQuery } from '@tanstack/react-query';
import { type LiveResource, toLiveResource } from '@/data/liveResource';
import { config } from './config';

interface LocationState {
  lastSync: Date;
  source: string;
  city: string;
  country: string;
  latitude: number;
  longitude: number;
}

const fetchLocationData = async (): Promise<Partial<LocationState>> => {
  const res = await fetch(config.url);
  const data = await res.json();

  const resultLastSync = new Date(data.timestamp).getTime();

  if (resultLastSync < Date.now() - 1000 * 60 * 60 * 24) {
    return {
      city: data.city,
      country: data.country,
      latitude: data.latitude,
      longitude: data.longitude,
    };
  }

  return {
    lastSync: new Date(resultLastSync),
    source: data.source,
    city: data.city,
    country: data.country,
    latitude: data.latitude,
    longitude: data.longitude,
  };
};

export const useLocation = (): LiveResource<Partial<LocationState>> => {
  const query = useQuery({
    queryKey: ['locationData'],
    queryFn: fetchLocationData,
    refetchInterval: config.refetchMiliseconds,
  });
  return toLiveResource(query, {
    source: (d) => d.source,
    freshAt: (d) => d.lastSync,
    staleAfterMs: config.staleAfterMiliseconds,
  });
};
